import classNames from "classnames";
import styles from "./index.module.less";
import { useMemo } from "react";
const Navs = ({
  anchors,
  active,
  onClick,
}: {
  anchors?: string[];
  active?: string;
  onClick?: (anchor: string) => void;
}) => {
  const isFirstThree = useMemo(() => {
    if (!active || !anchors) return false;
    const index = anchors.findIndex((anchor) => anchor === active);
    return index >= 0 && index < 3;
  }, [active, anchors]);
  const isLastThree = useMemo(() => {
    if (!active || !anchors) return false;
    const index = anchors.findIndex((anchor) => anchor === active);
    return index >= 0 && index >= anchors.length - 3;
  }, [active, anchors]);
  // 监听active变化，滚动到对应位置
  useMemo(() => {
    if (active) {
      const element = document.getElementById(`nav-${active}`);
      if (element) {
        // 横向滚动到对应位置
        const div = document.getElementById(`navs-container`) as any;
        div.scrollTo({
          behavior: "smooth",
          left:
            element.offsetLeft -
            element.parentElement!.offsetWidth / 2 +
            element.offsetWidth / 2,
        });
      }
    }
  }, [active]);
  return (
    <div
      className={classNames(styles.navList, {
        [styles.firstThree]: isFirstThree,
        [styles.lastThree]: isLastThree,
      })}
      id="navs-container"
    >
      {anchors?.map((anchor) => (
        <span
          key={anchor}
          onClick={() => {
            onClick?.(anchor);
          }}
          className={classNames(styles.nav, {
            // 没有 active 时，第一个高亮
            [styles.active]: active
              ? active === anchor
              : anchors[0] === anchor,
          })}
          id={`nav-${anchor}`}
        >
          {anchor}
        </span>
      ))}
    </div>
  );
};
export default Navs;
